<div *ngIf="offerConfig && offerConfig.offers" class="debug-info wt-text-base-s">
  <input class="btn-offer" type="button" value="Crea offerta generica" (click)="createOffer()">
  <input class="btn-offer" type="button" value="Ottieni ID flusso" (click)="getFlowId()">
  <input class="btn-offer" type="button" value="Genera flusso locale su ambiente" (click)="generateLocalFlow()">
  <ng-container *ngFor="let offer of offerConfig.offers">
    <input class="btn-offer" type="button" value="Crea {{offer}}" (click)="createOffer(offer)">
  </ng-container>
</div>
